import React from "react";
import styled from "styled-components";


export default styled.span`
    color: rgb(78 153 214);
    font-size: 21px;
    margin-right: 15px;
    display: ${(props) => (props.hidden ? "none" : "inline-block")};
    font-weight: 700;

    @media(max-width: 787px) {
        text-align: center;
        padding: 10px 0 10px 35px;
    }
`;
